import {
  TableAdapter,
  TableAdapterHook,
} from 'src/components/DataTable/types/DataTable';
import { createSearchAdapter } from 'src/components/DataTable/adapters/useSearchAdapter';
import {
  EmployeeSearchResultItem,
  EmployeeSearchResultItemResponse,
} from 'src/types/Employee';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import { EmployeeListFilters } from 'src/components/enterprise/features/Employee/utils/employee.utils';

export function createEmployeeListAdapter(
  corpId: string
): TableAdapterHook<EmployeeSearchResultItem, EmployeeListFilters> {
  const useSearchAdapter = createSearchAdapter<
    EmployeeSearchResultItemResponse,
    EmployeeListFilters
  >({
    searchUrl: `/corps/${corpId}/diners/search`,
  });

  return function useEmployeeListAdapter(): TableAdapter<
    EmployeeSearchResultItem,
    EmployeeListFilters
  > {
    const adapter = useSearchAdapter();

    return {
      ...adapter,
      data: adapter.data.map((employeeResponse) =>
        camelizeResponseData<EmployeeSearchResultItemResponse>(employeeResponse)
      ),
    };
  };
}
